angular.module('trainerWebApp.services').factory('Auth', ['$q', function ($q) {
  var userRole;
  var userPrivileges;
  var userRolePromise = $q.defer();
  var userPrivilegesPromise = $q.defer();

  function setUserPermissions(value) {
    userRole = value;
    userRolePromise.resolve(value);
  }

  function userRole() {
    return userRole;
  }

  function getRolePromise() {
    return userRolePromise.promise;
  }

  function setUserPrivileges(value) {
    userPrivileges = value;
    userPrivilegesPromise.resolve(value);
  }

  function hasUserPrivilege(privilege) {
    if (!userPrivileges) return false;
    return !!~userPrivileges.indexOf(privilege);
  }

  function getPrivilegesPromise() {
    return userPrivilegesPromise.promise;
  }

  return {
    setUserPermissions: setUserPermissions,
    userRole: userRole,
    getRolePromise: getRolePromise,
    setUserPrivileges: setUserPrivileges,
    hasUserPrivilege: hasUserPrivilege,
    getPrivilegesPromise: getPrivilegesPromise
  };
}]);
